<template>
  <div>
    <NavComponent />
    <b-container>
      <div>
        <div
          :style="{
            marginTop: '10px',
            marginBottom: '10px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '36%',
          }"
        >
          <div
            :style="{
              display: 'flex',
              alignItems: 'center',
            }"
          >
            <span
              :style="{
                backgroundColor: 'lightblue',
                padding: '3px',
              }"
              >{{ report.userId }}</span
            >
            <div
              :style="{
                marginRight: '5px',
              }"
            >
              : 신고 한 유저
            </div>
          </div>
          <div
            :style="{
              display: 'flex',
              alignItems: 'center',
            }"
          >
            <span :style="{ backgroundColor: 'lightcoral', padding: '3px' }">{{
              report.targetUserId
            }}</span>
            <div
              :style="{
                marginRight: '5px',
              }"
            >
              : 신고 당한 유저
            </div>
          </div>
        </div>
      </div>
      <div v-if="isV2" class="mt-3">
        <b-alert show variant="light" class="ai-report-reason">
          <div class="d-flex align-items-center mb-1">
            <strong class="mb-0 mr-2">AI 신고 사유</strong>
            <span
              v-if="reportReasonKey"
              class="badge badge-secondary report-reason-key"
            >
              {{ reportReasonKey }}
            </span>
          </div>
          <span v-if="automatedReportReason">{{ automatedReportReason }}</span>
          <span v-else class="text-muted">제공된 AI 신고 사유가 없습니다.</span>
        </b-alert>
      </div>
      <b-table
        :items="transcripts"
        :fields="transcriptFields"
        responsive="sm"
        small
        :tbody-tr-class="transcriptRowClass"
      >
        <template #head(user_id)>
          <span>User ID</span>
        </template>
        <template #cell(user_id)="data">
          <div :style="{ backgroundColor: getUserColor(data.item.user_id) }">
            {{ data.item.user_id }}
          </div>
        </template>

        <template #head(start)>
          <span>Start</span>
        </template>
        <template #cell(start)="data">
          {{ data.item.start }}
        </template>

        <template #head(end)>
          <span>End</span>
        </template>
        <template #cell(end)="data">
          {{ data.item.end }}
        </template>

        <template #head(text)>
          <span>Text</span>
        </template>
        <template #cell(text)="data">
          <div class="text-left">{{ data.item.text }}</div>
        </template>
      </b-table>
      <template v-if="chattingLogs.length">
        <h5 :style="{ marginTop: '32px' }">통화 중 채팅 기록</h5>
        <b-table :items="chattingLogs" :fields="chattingLogFields" responsive="sm" small>
          <template #head(user_id)>
        <span>User ID</span>
          </template>
          <template #cell(user_id)="data">
        <div :style="{ backgroundColor: getUserColor(data.item.user_id) }">
          {{ data.item.user_id }}
        </div>
          </template>

          <template #head(start)>
        <span>Start</span>
          </template>
          <template #cell(start)="data">
        {{ data.item.start }}
          </template>

          <template #head(text)>
        <span>Text</span>
          </template>
          <template #cell(text)="data">
        <div class="text-left">{{ data.item.text }}</div>
          </template>
        </b-table>
      </template>
    </b-container>
  </div>
</template>
<style>
.b-table td {
  padding: 0.5rem; /* Adjust as necessary */
}
.b-table th {
  padding: 0.5rem; /* Adjust as necessary */
}

.problematic-sentence {
  background-color: #fff3cd;
}

.ai-report-reason {
  white-space: pre-wrap;
}

.report-reason-key {
  font-size: 0.75rem;
}
</style>

<script>
import NavComponent from "../NavComponent";
import * as apis from "../../apis";
import {
  buildV2TranscriptRows,
  shouldHighlightSegment,
  normaliseReportReasonKey,
} from "./transcriptUtils";
import {
  createReportStateFromQuery,
  buildReportStateFromDetail,
  resetReportState,
} from "./reportContext.js";

export default {
  name: "CallContent",
  components: {
    NavComponent,
  },
  data() {
    const transcriptsApiVersion =
      this.$route.meta?.transcriptsApiVersion ?? "v2";
    const initialReportReasonKey = normaliseReportReasonKey(
      this.$route.query.reportReasonKey ?? this.$route.query.reportType ?? ""
    );
    const reportDefaults = createReportStateFromQuery(this.$route.query);
    return {
      roomId: this.$route.params.roomId,
      transcriptsApiVersion,
      isV2: transcriptsApiVersion === "v2",
      reportId: this.$route.query.reportId ?? null,
      messageTs: 0,
      transcripts: [],
      chattingLogs: [],
      userIds: [],
      problematicSentences: [],
      problematicSentenceSet: new Set(),
      automatedReportReason: "",
      initialReportReasonKey,
      reportReasonKey: initialReportReasonKey,
      reportDefaults,
      report: { ...reportDefaults },
      transcriptFields: [
        { key: "user_id", label: "User ID" },
        { key: "start", label: "Start" },
        { key: "end", label: "End" },
        { key: "text", label: "Text" },
      ],
      chattingLogFields: [
        { key: "user_id", label: "User ID" },
        { key: "start", label: "Start" },
        { key: "text", label: "Text" },
      ],
    };
  },
  created() {
    if (this.$session.get("token") === null) {
      this.$router.push({ name: "Login" });
      return;
    }
    if (!this.roomId) {
      this.$router.push({ name: "Home" });
      return;
    }
    this.initialise();
  },
  methods: {
    async initialise() {
      if (this.isV2) {
        await this.loadReportDetailIfNeeded();
      }
      await this.loadTranscripts();
      await this.loadChattingLogs();
    },
    getAuthHeaders() {
      return {
        Authorization: this.$session.get("token"),
      };
    },
    applyReportContext(reportDetail) {
      if (!reportDetail || typeof reportDetail !== "object") {
        this.report = resetReportState(this.reportDefaults);
        return;
      }
      const nextReport = buildReportStateFromDetail(
        reportDetail,
        this.reportDefaults
      );
      this.report = nextReport;
    },
    resetReportContext() {
      this.automatedReportReason = "";
      this.problematicSentences = [];
      this.problematicSentenceSet = new Set();
      this.reportReasonKey = this.initialReportReasonKey;
      this.report = resetReportState(this.reportDefaults);
    },
    async loadReportDetailIfNeeded() {
      if (!this.reportId) {
        this.resetReportContext();
        return;
      }
      await this.loadReportDetail(this.reportId);
    },
    async loadReportDetail(reportId) {
      try {
        const report = await apis.reports.fetchReportById(
          reportId,
          this.getAuthHeaders()
        );
        this.applyReportContext(report);
        const sentences = Array.isArray(report?.problematic_sentences)
          ? report.problematic_sentences
              .map((value) => Number(value))
              .filter((value) => !Number.isNaN(value))
          : [];
        this.automatedReportReason = report?.automated_report_content ?? "";
        this.problematicSentences = sentences;
        this.problematicSentenceSet = new Set(sentences);
        const reasonKey =
          normaliseReportReasonKey(report?.report_reason_key) ||
          normaliseReportReasonKey(report?.report_type);
        this.reportReasonKey = reasonKey || this.initialReportReasonKey;
      } catch (error) {
        console.error(error);
        this.resetReportContext();
      }
    },
    async loadTranscripts() {
      try {
        const transcripts = await apis.transcripts.fetchTranscriptByRoomId(
          this.roomId,
          this.getAuthHeaders(),
          this.transcriptsApiVersion
        );
        if (!transcripts?.length) {
          this.transcripts = [];
          this.userIds = [];
          return;
        }
        if (this.isV2) {
          this.transcripts = buildV2TranscriptRows(
            transcripts,
            this.formatTimeInMinute
          );
        } else {
          this.transcripts = this.groupTranscripts(transcripts);
        }
        this.userIds = [
          ...new Set(
            this.transcripts.map((transcript) => transcript.user_id)
          ),
        ];
      } catch (error) {
        console.error(error);
        this.transcripts = [];
        this.userIds = [];
      }
    },
    groupTranscripts(transcripts) {
      if (!Array.isArray(transcripts) || transcripts.length === 0) {
        return [];
      }
      const groupedTranscripts = [];
      let currentGroup = [];
      let currentStart = Number(transcripts[0].start) || 0;

      transcripts.forEach((transcript) => {
        const transcriptStart = Number(transcript.start) || 0;
        if (
          currentGroup.length &&
          transcriptStart - currentStart < 60 &&
          transcript.user_id === currentGroup[0].user_id
        ) {
          currentGroup.push(transcript);
        } else {
          if (currentGroup.length) {
            groupedTranscripts.push({
              user_id: currentGroup[0].user_id,
              start: Number(currentGroup[0].start) || 0,
              end: Number(currentGroup[currentGroup.length - 1].end) || 0,
              text: currentGroup.map((t) => t.text).join(" "),
            });
          }
          currentGroup = [transcript];
          currentStart = transcriptStart;
        }
      });

      if (currentGroup.length) {
        groupedTranscripts.push({
          user_id: currentGroup[0].user_id,
          start: Number(currentGroup[0].start) || 0,
          end: Number(currentGroup[currentGroup.length - 1].end) || 0,
          text: currentGroup.map((t) => t.text).join(" "),
        });
      }

      return groupedTranscripts.map((transcript) => ({
        ...transcript,
        start: this.formatTimeInMinute(transcript.start),
        end: this.formatTimeInMinute(transcript.end),
      }));
    },
    async loadChattingLogs() {
      try {
        const chattingLogs = await apis.chattingLogs.fetchChattingLogByRoomId(
          this.roomId,
          this.getAuthHeaders()
        );
        if (!chattingLogs?.length) {
          this.chattingLogs = [];
          return;
        }
        const chattingStartAt = new Date(chattingLogs[0].start).getTime();

        this.chattingLogs = chattingLogs.map((chattingLog) => ({
          ...chattingLog,
          start: this.formatTimeInMinute(
            (new Date(chattingLog.start).getTime() - chattingStartAt) / 1000
          ),
        }));

        this.userIds = [
          ...new Set(
            this.chattingLogs.map((chattingLog) => chattingLog.user_id)
          ),
        ];
      } catch (error) {
        console.error(error);
        this.chattingLogs = [];
      }
    },
    getUserColor(userId) {
      const colors = {
        [this.report.targetUserId]: "lightcoral",
        [this.report.userId]: "lightblue",
      };
      return colors[userId];
    },
    formatTimeInMinute(secondValue) {
      const seconds = Math.max(0, Number(secondValue) || 0);
      const minutes = Math.floor(seconds / 60);
      const remainder = Math.floor(seconds % 60);
      const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
      const formattedSeconds = remainder < 10 ? `0${remainder}` : `${remainder}`;
      return `${formattedMinutes}:${formattedSeconds}`;
    },
    isProblematic(segment) {
      if (!this.isV2 || !segment) {
        return false;
      }
      const targetUserId = this.report ? this.report.targetUserId : null;
      return shouldHighlightSegment(
        segment,
        this.problematicSentenceSet,
        targetUserId
      );
    },
    transcriptRowClass(item, type) {
      if (type !== "row" || !item || !this.isV2) {
        return null;
      }
      return this.isProblematic(item) ? "problematic-sentence" : null;
    },
  },
};
</script>
